export var illustrationTheme = {
  baseStyle: {
    display: 'inline-flex'
  },
  sizes: {
    small: {
      height: '96px'
    },
    medium: {
      height: '120px'
    },
    large: {
      height: '144px'
    }
  },
  defaultProps: {
    size: 'medium'
  }
};
//# sourceMappingURL=Illustration.theme.js.map